export const getKey = (key: any) => {
  if (typeof window === "undefined") {
    return false;
  }
  if (localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else {
    return false;
  }
};
export const accessToken = () => {
  return getKey("token");
};